import { ReactNode } from 'react';
import { defineMessage } from 'react-intl';

import { HtmlTitle } from '@ocx-app/components/router/HtmlTitle';
import { BackButton } from '@ocx-app/components/Layout/NavigationBar/BackButton/BackButton';
import { VendorLogo } from '@ocx-app/components/Layout/NavigationBar/VendorLogo/VendorLogo';

import { NavigationBar, Page, PageContent } from '@ocx/ui';

type SelectPumpLayoutProps = {
  children: ReactNode;
};

export const SelectPumpLayout = ({ children }: SelectPumpLayoutProps) => {
  return (
    <Page>
      <HtmlTitle
        title={defineMessage({
          id: 'selectPump:htmlTitle',
          defaultMessage: 'Select pump',
          description: 'HTML title tag for Select pump page',
        })}
      />
      <NavigationBar left={<BackButton />} center={<VendorLogo />} />
      <PageContent bgcolor="background.paper">{children}</PageContent>
    </Page>
  );
};
